import { Redirect, Route, Switch } from 'react-router-dom';
import { useAccessibleRoutes } from './hooks/useAccessibleRoutes';
import { type ManageConnectionsAccess } from './subroutes';
import { StyledSubNavigation } from './styles';
import { SubNavWrapper } from '../../styled';

const ManageConnections = ({
  access,
  location,
}: {
  access: ManageConnectionsAccess;
  location: { pathname: string; search: string };
}) => {
  const accessibleSubroutes = useAccessibleRoutes(access);
  const firstRoute = Object.values(accessibleSubroutes)[0];

  return (
    <>
      <SubNavWrapper>
        <StyledSubNavigation
          small
          routes={accessibleSubroutes}
          currentSearch={location.search}
        />
      </SubNavWrapper>
      <Switch>
        {Object.entries(accessibleSubroutes).map(([key, route]) => {
          const Component = route.component;
          return (
            <Route
              key={key}
              path={route.path}
              exact={route.exact}
              render={() => <Component access={access} />}
            />
          );
        })}
        {firstRoute && <Redirect to={firstRoute.path} />}
      </Switch>
    </>
  );
};

export default ManageConnections;
